// Imports
import AnimateHeight from 'react-animate-height';


// Define the accepted props
interface Props extends React.PropsWithChildren {
	isDisplayed: boolean;
}


// Function component
const ConditionalField: React.FC<Props> = ({ isDisplayed, children }) => (
	<AnimateHeight
		duration={400}
		animateOpacity={true}
		height={isDisplayed ? 'auto' : 0}
		className={isDisplayed ? 'is-displayed' : undefined}
	>
		{children}
	</AnimateHeight>
);

export default ConditionalField;
